import React, {useEffect, useState} from "react";
import {Col, Row, Card, Button, Icon} from "antd";
import publicUsersApi from '@api/public-user'
import Search from "./Search";
import Chart from "./Chart";


function DeviceReport() {
  const [state, setState] = useState({
    isFetched: false,
    downloadUrl: "",
    data : []
  });
  
  useEffect(() => {
    fetch()
  }, []);
  
  const fetch = (params={}) => {
    publicUsersApi.getDeviceReport({
        params
      })
      .then(({data, meta}) => {
        setState({
          isFetched: true,
          data
        })
      })
      .catch()
  };
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card bordered={false}>
          <Search search={fetch}/>
        </Card>
      </Col>
      <Col span={24}>
        {state.data.length > 0 && <Chart data={state.data}/>}
      </Col>
    </Row>
  )
}

export default DeviceReport;

